export enum PaymentMethod {
    DirectDebit,
    Transfer,
    // CreditCard,
    // Paypal
}